import { LOCALES } from 'i18n/locales';

export const listEnquiryPageIntl = {
    [LOCALES.ENGLISH]: {
        'listEnquiryPage.page.title': 'Enquiries',
        'listEnquiryPage.success.title': 'Success',
        'listEnquiryPage.success.message': 'Created Enquiry {0}',
        'listEnquiryPage.planned': 'Planned',
        'listEnquiryPage.emergency': 'Emergency',
        'listEnquiryPage.viewOnMap': 'View on map',
        'listEnquiryPage.action': 'Action',
        'listEnquiryPage.viewEnquiry': 'View enquiry',
        'listEnquiryPage.delete': 'Delete',
        'listEnquiryPage.delete.success.title': 'Enquiry deleted',
        'listEnquiryPage.delete.success': 'The enquiry "{title}" has been deleted.',
        'listEnquiryPage.delete.modal.title': 'Delete enquiry?',
        'listEnquiryPage.delete.modal.body': 'Deleting "{title}" removes it from your list of enquiries.',
        'listEnquiryPage.delete.modal.confirm': 'Delete enquiry',
        'listEnquiryPage.delete.modal.cancel': 'Cancel'
    },
    [LOCALES.WELSH]: {
        'listEnquiryPage.page.title': 'Ymholiadau',
        'listEnquiryPage.success.title': 'Llwyddiant',
        'listEnquiryPage.success.message': 'Ymholiad a Grëwyd {0}',
        'listEnquiryPage.planned': 'Wedi\'i gynllunio',
        'listEnquiryPage.emergency': 'Argyfwng',
        'listEnquiryPage.viewOnMap': '[View on map]',
        'listEnquiryPage.action': '[Action]',
        'listEnquiryPage.viewEnquiry': '[View enquiry]',
        'listEnquiryPage.delete': '[Delete]',
        'listEnquiryPage.delete.success.title': '[Enquiry deleted]',
        'listEnquiryPage.delete.success': '[The enquiry "{title}" has been deleted.]',
        'listEnquiryPage.delete.modal.title': '[Delete enquiry?]',
        'listEnquiryPage.delete.modal.body': '[Deleting "{title}" removes it from your list of enquiries.]',
        'listEnquiryPage.delete.modal.confirm': '[Delete enquiry]',
        'listEnquiryPage.delete.modal.cancel': '[Cancel]'
    }
};
